import type { TreeNode } from './permission-model';

/** 권한 트리 더미 — 그룹 → 하위 그룹 → 항목 3단. 특정 서비스와 무관한 일반 용어. */
const actions = (prefix: string, labels: string[]): TreeNode[] =>
  labels.map((label, index) => ({ id: `${prefix}.${String(index)}`, label }));

export const PERMISSION_TREE: TreeNode[] = [
  {
    id: 'content',
    label: '콘텐츠',
    children: [
      {
        id: 'content.post',
        label: '게시물',
        children: actions('content.post', ['조회', '작성', '수정', '삭제']),
      },
      {
        id: 'content.file',
        label: '파일',
        children: actions('content.file', ['조회', '업로드', '삭제']),
      },
    ],
  },
  {
    id: 'member',
    label: '멤버',
    children: [
      {
        id: 'member.list',
        label: '멤버 목록',
        children: actions('member.list', ['조회', '내보내기']),
      },
      {
        id: 'member.role',
        label: '역할',
        children: actions('member.role', ['조회', '부여', '회수']),
      },
      { id: 'member.invite', label: '초대', children: actions('member.invite', ['발송', '취소']) },
    ],
  },
  {
    id: 'setting',
    label: '설정',
    children: [
      {
        id: 'setting.general',
        label: '일반',
        children: actions('setting.general', ['조회', '변경']),
      },
      {
        id: 'setting.security',
        label: '보안',
        children: actions('setting.security', ['조회', '변경', '접속 기록 조회']),
      },
    ],
  },
];

/** 저장된 상태로 가정하는 선택(항목 id) */
export const INITIAL_SELECTION = [
  'content.post.0',
  'content.post.1',
  'content.file.0',
  'member.list.0',
];
